module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn-ir-stock-4ccc9eef94d07108fafd69a5c4a1058e.svg";